import { get } from "lodash";

export const getMediaByKey = (post, key) => {
    if(!post.media) {
        return null;
    }
    return get(post.media, ['sizes', key]);
};

export default {};